import type { Material } from 'product/types/ProductDetails'
import { QualitiesId, type Quality } from '../../components/Qualities/constants'

export const getQuality = ({ id, percent }: Material): Quality | null => {
	const quality = QualitiesId[id]
	if (!quality || percent < quality.minimumPercentage) {
		return null
	}

	return quality
}
